import React, { useState } from 'react';
import './SendResetLink.css';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axiosInstance from '../../services/AxiosInstance';
import { useNavigate } from 'react-router-dom';


const SendResetLink = () => {
  const navigate = useNavigate();
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const initialValues = { email: '' };
  const validationSchema = Yup.object({
    email: Yup.string().email('Invalid email address').required('Email is required'),
  });

  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      // Replace with your backend endpoint
      await axiosInstance.post('/auth/forgotpassword/request-reset', { email: values.email });
      toast.success('Reset link sent! Please check your email.');

      setShowSuccessMessage(true);
      resetForm();
      setSubmitting(false);
      setTimeout(() => {
        navigate('/login')
      }, 3000);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setSubmitting(false);
        toast.error('Invalid email');
      } else if (error.response && error.response.status === 404) {
        toast.error('Email not found in the system');
      } else {
        toast.error(
          error.response?.data?.message || 'Failed to send reset link. Please try again.'
        );
      }
    }
  };

  return (
    <div className="d-flex flex-column justify-content-start align-items-center min-vh-100" style={{ backgroundColor: '#f8f8f8' }}>
      <ToastContainer />
      <div className='hero-landing'>
        <h1 className="text-center mb-4 text-white display-5">Forgot Password</h1>
        <p className="text-center text-white pricing-sub-title">
          Enter your email to receive a password reset link.
        </p>
      </div>
      <div style={{ maxWidth: 400, width: '100%', padding: "2rem", marginBottom: "5rem" }}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ isSubmitting }) => (
            <Form className='forgot-form'>
              <div className="mb-3 w-100">
                <label htmlFor="email" className="form-label"><strong>Email</strong></label>
                <Field
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter your email"
                  style={{ width: '100%' }}
                />
                <ErrorMessage name="email" component="div" className="text-danger small mt-1" />
              </div>

              {showSuccessMessage && (
                <div className="col-lg-12 mt-2">
                  <p style={{ fontSize: '0.85rem', color: 'gray' }}>
                    We have sent you an email with the link to reset your password. Please check your inbox/spam folder and follow the instruction
                  </p>
                </div>
              )}

              <button
                type="submit"
                className="reset-link-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Reset Link'}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default SendResetLink; 